import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { indexBlocks, type SiteBlockMap } from "@/lib/siteContent";

type Row = { page_slug: string; block_key: string; value: string };

/**
 * Loads all site_content rows for a given page (public read).
 * Returns a key->value map of overrides; use getBlock(map, key, fallback)
 * in components so the page still renders if the DB is empty.
 */
export function useSiteContent(page_slug: string): { blocks: SiteBlockMap; isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ["site_content", page_slug],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("site_content")
        .select("page_slug, block_key, value")
        .eq("page_slug", page_slug);
      if (error) throw error;
      return (data as Row[]) ?? [];
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
  return { blocks: indexBlocks(data ?? [], page_slug), isLoading };
}